// Admin Analytics → Deflect endpoints, one per card (chargeback_back consumer_clarity/views/admin_analytics.py).
import { CancelToken } from "apisauce"

import { request } from "../../../Services/Api"

// The thunk's abort signal cancels the request through a cancel token: axios 0.21 reads no signal.
const cancelledBy = (signal) =>
  new CancelToken((cancel) => signal.addEventListener("abort", () => cancel()))

export const getLookupsOverview = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/lookups-overview/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getLookupVolume = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/lookup-volume/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getActiveMerchants = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/active-merchants/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getUnbillableChannels = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/unbillable-channels/", params, {
    cancelToken: cancelledBy(signal)
  })

// The card's New values and All values, a page at a time (CHA1-4558).
export const getUnbillableNewValues = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/unbillable-channels/new-values/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getUnbillableAllValues = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/unbillable-channels/all-values/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getMatchRate = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/match-rate/", params, {
    cancelToken: cancelledBy(signal)
  })

// The card's Worst merchants, a page at a time (CHA1-4558).
export const getWorstMerchants = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/match-rate/worst-merchants/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getRevenue = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/revenue/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getAverageValue = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/average-value/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getRecordsByStatus = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/records-by-status/", params, {
    cancelToken: cancelledBy(signal)
  })

export const getTimeToActive = (params, signal) =>
  request.api.get("/consumer-clarity/admin-analytics/time-to-active/", params, {
    cancelToken: cancelledBy(signal)
  })
